// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Ub-z","heading":"Vb-z","brandPromo":"Wb-z"};